/**
 * Staff / partner classification for analytics person properties.
 * Centralized so multiple consumers (analytics identity, Frill) can share one classification.
 */

const VERDI_EMAIL_DOMAINS = ["@verdiag.com", "@verdi.ag"];
const VERDI_ADMIN_ROLE = "Verdi Administrator";
const CHANNEL_PARTNER_ROLE = "Channel Partner";

type StaffFlagInput = {
    email?: string;
    roleNames?: string[];
    isAdmin?: boolean;
};

/** Verdi staff: an internal email domain, the admin role, or an active admin session. */
export function checkIsVerdiStaff({ email, roleNames = [], isAdmin = false }: StaffFlagInput): boolean {
    const normalizedEmail = (email ?? "").toLowerCase();
    return Boolean(
        VERDI_EMAIL_DOMAINS.some((domain) => normalizedEmail.endsWith(domain)) ||
            roleNames.includes(VERDI_ADMIN_ROLE) ||
            isAdmin,
    );
}

/** Channel partner (non-Verdi reseller / integrator). */
export function checkIsPartner(roleNames: string[] = []): boolean {
    return roleNames.includes(CHANNEL_PARTNER_ROLE);
}
